<template>
  <v-container id="centre-container">
    <v-row>
      <v-col lg="12" md="12" sm="12">
        <CertificationsTable
          :headers="pendingCertificationsHeaders"
          :items="pendingCertifications"
          :title="'Certification Requests'"
          :isLoading="isPendingCertificationsLoading"
        />
      </v-col>
      <v-col lg="12" md="12" sm="12">
        <PendingLearnersTable
          :headers="pendingLearnersHeaders"
          :items="unduplicatedLearners"
          :title="'Learner Requests'"
          :isLoading="isPendingLearnersLoading"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CertificationsTable from "./CertificationsTable";
import PendingLearnersTable from "./PendingLearnersTable";

export default {
  mounted: function () {
    this.getPendingCertifications();
    this.getPendingLearners();
  },
  components: {
    CertificationsTable,
    PendingLearnersTable,
  },
  data() {
    return {
      isPendingCertificationsLoading: true,
      isPendingLearnersLoading: true,
      pendingCertifications: [],
      pendingLearners: [],
      pendingCertificationsHeaders: [
        { text: "Learner Name", value: "learnerName" },
        { text: "Status", value: "status" },
      ],
      pendingLearnersHeaders: [
        { text: "Learner Name", value: "learnerName" },
        { text: "Status", value: "status" },
      ],
    };
  },
  computed: {
    unduplicatedLearners: function () {
      const learnerList = [];

      for (let i = 0; i < this.pendingLearners.length; i++) {
        let duplicate = false;
        for (let j = 0; j < learnerList.length; j++) {
          if (this.pendingLearners[i].code == learnerList[j].code) {
            duplicate = true;
            break;
          }
        }

        if (!duplicate) {
          learnerList.push(this.pendingLearners[i]);
        }
      }

      return learnerList;
    },
  },
  watch: {
    isPendingCertificationsLoading: function (newValue) {
      this.isPendingCertificationsLoading = newValue;
    },
    isPendingLearnersLoading: function (newValue) {
      this.isPendingLearnersLoading = newValue;
    },
  },
  methods: {
    getPendingCertifications: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/certifications/pending`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          this.isPendingCertificationsLoading = false;
          this.pendingCertifications = data.certifications;

          if (this.$store.state.role == "centre") {
            this.pendingCertifications = this.pendingCertifications.map(
              (cert) => {
                if (cert.status == "moderation") {
                  cert.status = "Assessment upload required";
                } else if (cert.status == "submitted") {
                  cert.status = "Waiting for moderation";
                }
                return cert;
              }
            );
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getPendingLearners: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/learners/pending`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.isPendingLearnersLoading = false;
          this.pendingLearners = data.pendingLearners;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
#centre-container {
  min-height: 100vh;
}
</style>